import { render, staticRenderFns } from "./InvisibleRecaptchaElementBlock.vue?vue&type=template&id=05f1e935&"
import script from "./InvisibleRecaptchaElementBlock.vue?vue&type=script&lang=js&"
export * from "./InvisibleRecaptchaElementBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports